import { useEffect, useMemo } from "react";
import { useAppContext } from "../contexts/AppContext";
import { initGoogleAnalytics, parseMeasurementIds } from "../util/googleAnalytics";
import { ensureGtagForGoogleAds, initGoogleAdsConversion, parseGoogleAdsSendTo } from "../util/googleAds";

const GoogleAnalytics: React.FC = () => {
    const { branding, deploymentMode } = useAppContext();

    const measurementIds = useMemo(
        () => parseMeasurementIds(branding?.googleAnalytics),
        [branding?.googleAnalytics]
    );
    const googleAdsSendTo = useMemo(
        () => parseGoogleAdsSendTo(branding?.googleAdsConversionSendTo),
        [branding?.googleAdsConversionSendTo]
    );

    useEffect(() => {
        if (measurementIds.length) {
            initGoogleAnalytics(measurementIds, {
                debug: deploymentMode === "Development",
            });
        } else if (googleAdsSendTo) {
            ensureGtagForGoogleAds(googleAdsSendTo);
        }

        if (googleAdsSendTo) {
            initGoogleAdsConversion(googleAdsSendTo);
        }
    }, [measurementIds, googleAdsSendTo, deploymentMode]);

    return null;
};

export default GoogleAnalytics;
